import AutoCompleteDropdown from "../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import { useCaseSearch } from "../../hooks/useCaseSearch";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import sharedStyles from "../../styles/styles";

import CustomListBox from "./CustomListBox";
import DropdownTitle from "./DropdownTitle";

export default function CaseDropdown({ placeholder }) {
  const { selectedCase, setSelectedCase, setDisableCopyButton, setNavigationCaseId } =
    useAISummaryStore();

  const { data, setSearch, loading, showMore, handleShowMore } = useCaseSearch();

  const handleInputChange = (_, value, reason) => {
    const inputValue = value || "";
    setSearch(inputValue);

    if (reason === "clear") {
      setSelectedCase(null);
      setNavigationCaseId(null);
      setDisableCopyButton(true);
    }
  };

  const handleValueChange = (_, value) => {
    setSelectedCase(value || null);
    setNavigationCaseId(value?.id || null);
    setDisableCopyButton(!value);
  };

  const options = data.map(({ id, label }) => ({ id, label }));

  return (
    <div className="flex flex-col gap-0 justify-start">
    <DropdownTitle label={"Case"} sx={sharedStyles.label(false)} />
    <AutoCompleteDropdown
      data={options}
      initValue={selectedCase}
      multiple={false}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      onInputChange={handleInputChange}
      onValueChange={handleValueChange}
      placeholder={placeholder}
      ListboxComponent={CustomListBox}
      ListboxProps={{
        showMore,
        setShowMore: handleShowMore,
        sx: { overflow: "auto", maxHeight: 200 },
      }}
      dropdownSx={sharedStyles.selectMenuPaper}
      loading={loading}
      textFieldSx={{
        ...sharedStyles.textField,
        "&.MuiFormControl-root":{
            height:"100%",
        }
    }}
    />
    </div>
  );
}
